// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoHeader","title":"todoHeader-m__title__3tjiT","newTodo":"todoHeader-m__newTodo__3Rwh3","toggleAll":"todoHeader-m__toggleAll__15rbk"};